import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routeHelper, storageHelper } from '../helpers';
import { eventActions, rootActions } from '../redux/actions';
import { axios } from '../utils';
import { urlsConfig } from 'src/configs';

const useLogout = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const logout = () => {
    axios.setToken(undefined);
    axios.setEventId(undefined);
    storageHelper.reset();
    dispatch(eventActions.eventIdChanged(''));

    const source = localStorage.getItem('source');

    if (source === 'nginr') {
      window.open(urlsConfig.nginrUrl, '_self');
    } else if (urlsConfig.systemLogin) {
      window.open(urlsConfig.appBaseURL, '_self');
    } else {
      dispatch(rootActions.resetReducerStatesToDefault());
      routeHelper.handleRoute(history, '/');
    }
  };

  return logout;
};

export default useLogout;
